/**
 * Checkbox mit dem Glyph aus Win11Theme::PaintCheckboxGlyphCore():
 * abgerundete Box (Radius 18 % der Kantenlänge), im Zustand "checked"
 * accent-gefüllt mit Haken in Hintergrundfarbe (Punkte 0.20/0.55 →
 * 0.42/0.75 → 0.82/0.28, Strichbreite 11 %).
 */

const SVG_NS = 'http://www.w3.org/2000/svg';

/** `checked` fuer Verwendungen ohne `<input>`-Geschwister (Menues, Listen). */
export function createCheckboxGlyph(checked = false): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '0 0 1 1');
  svg.setAttribute('aria-hidden', 'true');
  svg.classList.add('cm-check__glyph');
  if (checked) svg.classList.add('cm-check__glyph--checked');

  const box = document.createElementNS(SVG_NS, 'rect');
  box.setAttribute('x', '0.05');
  box.setAttribute('y', '0.05');
  box.setAttribute('width', '0.9');
  box.setAttribute('height', '0.9');
  box.setAttribute('rx', '0.18');
  box.classList.add('cm-check__box');

  const tick = document.createElementNS(SVG_NS, 'polyline');
  tick.setAttribute('points', '0.20,0.55 0.42,0.75 0.82,0.28');
  tick.classList.add('cm-check__tick');

  svg.append(box, tick);
  return svg;
}

export interface CheckboxOptions {
  checked?: boolean;
  title?: string;
  onChange?: (checked: boolean) => void;
}

export interface CheckboxHandle {
  element: HTMLLabelElement;
  input: HTMLInputElement;
}

export function createCheckbox(text: string, options: CheckboxOptions = {}): CheckboxHandle {
  const label = document.createElement('label');
  label.className = 'cm-check';

  const input = document.createElement('input');
  input.type = 'checkbox';
  input.checked = options.checked ?? false;

  const caption = document.createElement('span');
  caption.textContent = text;

  label.append(input, createCheckboxGlyph(), caption);
  if (options.title !== undefined) label.title = options.title;

  const { onChange } = options;
  if (onChange) {
    input.addEventListener('change', () => onChange(input.checked));
  }

  return { element: label, input };
}
